import React, { useState, useEffect, useCallback } from "react";
import { Button, Gallery, TabPanel } from 'devextreme-react';
import notify from 'devextreme/ui/notify';
import * as Fnctn from '../../contexts/GenericFunctions';
import { halcoloaderActive, halcoloaderRemove } from '../../contexts/HalcoLoader';
import { connect, useSelector } from 'react-redux';
import { RootState } from '../../reduxStore/reducers';
import { Link } from 'react-router-dom';
import '../Cuorses/View_Cursos.scss';
import Evaluacion from '../OverView/DetalleTarea/EvaluacionTarea/view_EvaluacionTarea';
import * as OB_actions from '../../reduxStore/OverBoard/OB_actions';
import * as CRS_actions from '../../reduxStore/Courses/ViewCourse/CRS_action';
import { useDispatch } from 'react-redux';
import { ActualizarEstatusTarea } from '../../api/DataOnBoarding';

interface IProps {};

const View_Cursos: React.FC<IProps> = (props: any) => {
    const [IdCourse] = useState<string>(props.Select_Id_Course);
    const [Courses, setCourses] = useState<any[]>();
    const [Title, setTitle] = useState<string>();
    const [IndexCourse, setIndexCourse] = useState<number>(0);
    const dispatch = useDispatch();
    const selectedIndexFromRedux = useSelector((state: RootState) => state.View_Course.SelectedIndex);

    const GetDataCourse = async () => {
        try {
            halcoloaderActive();
            let info = await Fnctn.getCookie();
            let dtResult: any = await Fnctn.postData(`/training/get_pending_courses_user/${IdCourse}/${info._id}`, "GET", {});
            dtResult = await dtResult.json();
            dtResult = dtResult.data;
            
            // Ordenar por orden
            dtResult.sort((a: any, b: any) => a.order - b.order);
            
            // Encontrar la primera tarea no completada
            const incompleteTasks = dtResult.filter((item: any) => item.onbording_estatus !== "Completed");
            const initialIndex = incompleteTasks.length > 0 ? dtResult.indexOf(incompleteTasks[0]) : 0;
            
            // Restaurar el índice guardado en Redux si existe y es válido
            const cursoAlmacenado = selectedIndexFromRedux >= 0 && selectedIndexFromRedux < dtResult.length ? selectedIndexFromRedux : initialIndex;
            
            setTitle(dtResult[cursoAlmacenado].title);
            setIndexCourse(cursoAlmacenado);
            dispatch(CRS_actions.set_course_selected_index(cursoAlmacenado));
            
            setCourses(dtResult);
            halcoloaderRemove();
        }
        catch (error) {
            halcoloaderRemove();
            notify(error, "error");
        }
    };

    const changeItem = async (e: any) => {
    try {
        if (e.name === "selectedIndex") {
            const newIndex = e.value;
            const previousIndex = e.previousValue;

            if (newIndex === previousIndex) return;

            const items = e.component._dataSource._items;
            const previousItem = items[previousIndex];
            const currentItem = items[newIndex];

            if (
                newIndex > previousIndex &&
                !Fnctn.NullUndefinedEmpty(previousItem.evaluation_id) &&
                previousItem.answers.length <= 0
            ) {
                notify("Para continuar debes responder el cuestionario o evaluación", "error");
                return;
            }

            setTitle(currentItem.title);
            setIndexCourse(newIndex);
            dispatch(CRS_actions.set_course_selected_index(newIndex));

            if (newIndex > previousIndex) {
                if (
                    Fnctn.NullUndefinedEmpty(previousItem.evaluation_id) ||
                    previousItem.answers.length > 0
                ) {
                    await ActualizarEstatusTarea(previousItem.onbording_task_id, 'Completed');
                }
            }
        }
    } catch (error) {
        halcoloaderRemove();
        notify(error, "error");
    }
};

    const refreshCourse = async () => {
        GetDataCourse();
    };

    const contentAttachmentRender = ((dt: any) => {
        if (dt.extension.includes("mp4")) {
            return <p style={{ width: 'auto' }}>
                <video controls id={dt.url} className='VideoTarea'>
                    <source className='Source' src={dt.url + `#t=0,7`} />
                </video>
            </p>;
        }
        else {
            return <div className='cardFile-content' id={dt.url} onClick={() => Fnctn.OpenFile(dt.url)}>
                {dt.archive_name}<br />
                <embed src={dt.url} style={{ width: '80%', height: '35rem' }}></embed>
            </div>;
        }
    });

    const divAttachments: any = useCallback((dt: any) => {
        return (
            <Gallery
                id='VideosGaleria'
                dataSource={dt}
                width={"60hv"}
                height={"auto"}
                slideshowDelay={0}
                loop={false}
                showNavButtons={true}
                showIndicator={true}
                itemRender={(e) => contentAttachmentRender(e)}
            />
        );
    }, []);

    const divContent: any = useCallback((dt: any) => {
        let Attachments: any[] = dt.attachments;
        let itemGallery: any[] = [
            <div /*className='cardFile'*/>
                <div /*className='cardFile-content' id={dt.url} /*onClick={() => Fnctn.OpenFile(dt.url)}*/>
                    <div className='contenidoTarea' dangerouslySetInnerHTML={{ __html: dt.content }} />
                </div>
            </div>
        ];

        if (Attachments.length > 0) {
            let enlacesMedia: any[] = Attachments.filter((item: { [key: string]: any }) => item.extension !== "iframe");
            let galleryAttachment = divAttachments(enlacesMedia);
            itemGallery.push(galleryAttachment);

            let enlacesExternos: any[] = Attachments.filter((item: { [key: string]: any }) => item.extension === "iframe");
            if (enlacesExternos.length > 0) {
                enlacesExternos.forEach((item: { [key: string]: any }) => {
                    itemGallery.push(
                        <div className="IframeLinkExterno" >
                            <div style={{ position: "relative", paddingBottom: "56.25%", paddingTop: "0", height: "100%" }}>
                                <iframe title="IND ORG TZ 2024" frameBorder={"0"} style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%" }} src={item.url} typeof="text/html" allowFullScreen={true} scrolling="yes"></iframe>
                            </div>
                        </div>
                    );
                });
            }
        };

        if (!Fnctn.NullUndefinedEmpty(dt.evaluation_id) && dt.answers.length <= 0) {
            itemGallery.push(<Evaluacion refreshCourse={refreshCourse} ></Evaluacion>);
        }

        return (<>{itemGallery}</>)
    }, [divAttachments, refreshCourse]);

    useEffect(() => {
        GetDataCourse();
    }, [IdCourse]);

    useEffect(() => {
        if (Courses && Courses.length > 0) {
            if (selectedIndexFromRedux >= 0 && selectedIndexFromRedux < Courses.length) {
                setIndexCourse(selectedIndexFromRedux);
                setTitle(Courses[selectedIndexFromRedux].title);
            } else if (IndexCourse >= Courses.length) {
                setIndexCourse(0);
                setTitle(Courses[0].title);
            }
        } else {
            setIndexCourse(0);
        }
    }, [Courses, selectedIndexFromRedux]);

    useEffect(() => {
        if (Courses && Courses.length > 0 && IndexCourse >= 0 && IndexCourse < Courses.length) {
            const currentCourse = Courses[IndexCourse];
            
            if (!Fnctn.NullUndefinedEmpty(currentCourse.evaluation_id) && currentCourse.answers.length <= 0) {
                dispatch(OB_actions.set_id_Evaluacion(currentCourse.evaluation_id));
                dispatch(OB_actions.set_type_form("C"));
                dispatch(OB_actions.set_id_segmentacion(currentCourse.onbording_task_id));
            } 
            else if (
                Fnctn.NullUndefinedEmpty(currentCourse.evaluation_id) || 
                (!Fnctn.NullUndefinedEmpty(currentCourse.evaluation_id) && currentCourse.answers.length > 0)
            ) {
                if (currentCourse.onbording_estatus !== "Completed") {
                    ActualizarEstatusTarea(currentCourse.onbording_task_id, 'Completed');
                }
            }
        }
        else {
            setIndexCourse(0)
        }
    }, [Courses, IndexCourse, dispatch]);

    return (
        <div className='divPrincipal'>
            <div className='buttonAtras2' style={{ display: 'flex' }} >
                <div style={{ width: '70%', alignSelf: 'center' }}>
                    <Link to={'/CoursePg'}>
                        <Button className='btnAtras' icon="back" text="Atras" ></Button>
                    </Link>
                </div>
            </div>
            <div className={'content-block dx-card responsive-paddings'} style={{ margin: "30px auto 30px auto", width: "95%" }}>
                <TabPanel
                    tabsPosition={"right"}
                    dataSource={Courses}
                    deferRendering={true}
                    animationEnabled={true}
                    swipeEnabled={true}
                    selectedIndex={IndexCourse}
                    showNavButtons={true}
                    itemTitleRender={(data) => {
                        const isCompleted = data.onbording_estatus === "Completed";
                        return (
                            <span style={{ 
                                color: isCompleted ? "#32CD32" : "#000",
                                fontWeight: isCompleted ? "normal" : "normal"
                            }}>
                                {data.title}
                            </span>
                        );
                    }}
                    onOptionChanged={changeItem}
                    itemRender={divContent}
                    width={"100%"}
                    height={"100%"}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        Select_Id_Course: state.View_Course.Id_Course
    }
};
const mapDispatchToProps = (dispatch: any) => { return {} };

export default connect(mapStateToProps, mapDispatchToProps)(View_Cursos);